import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import * as ROUTES from '../constants/routes';
import Cookies from 'js-cookie';

import Icon from './Icon';

const cookieName = 'cookie-use';

export default function Cookie() {
  const [isAccepted, setIsAccepted] = useState(Cookies.get(cookieName));

  useEffect(() => {
    const navbar = document.querySelector('.navbar');
    if (isAccepted) {
      navbar.classList.add('no-cookie-notification');
      navbar.style.top = '0';
    } else {
      navbar.classList.remove('no-cookie-notification');
      navbar.style.top = '40px';
    }
  }, [isAccepted]);

  function handleClose() {
    Cookies.set(cookieName, true, { expires: 365 * 10 });
    setIsAccepted(true);
  }

  if (isAccepted) {
    return null;
  }

  return (
    <div className="cookie-notification">
      <div className="container p-2">
        <div className="row">
          <div className="col text-center">
            By using Reputelo you agree to our{' '}
            <Link to={ROUTES.CU} style={{ color: '#F5F5D1' }}>Cookie Policy.</Link>
            <button className="btn p-0 ml-2" onClick={handleClose}>
              <Icon icon="times" fixedWidth style={{ color: 'white' }} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
